import { render, staticRenderFns } from "./freightYF.vue?vue&type=template&id=4f142ce0&scoped=true&"
import script from "./freightYF.vue?vue&type=script&lang=js&"
export * from "./freightYF.vue?vue&type=script&lang=js&"
import style0 from "./freightYF.vue?vue&type=style&index=0&id=4f142ce0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f142ce0",
  null
  
)

export default component.exports